import { getGoogleMapsLat, getGoogleMapsLong } from "@utils/configuration/aem";
import { isDefined } from "@utils/helpers";
import { RefObject } from "react";
import { ZOOM_INITIAL } from "../storeSearch.config";

let map: woosmap.map.Map | undefined = undefined

export const useMap = (mapElementRef: RefObject<HTMLDivElement>) => {
    if (!isDefined(mapElementRef.current)) return;

    map ||= new woosmap.map.Map(mapElementRef.current, {
        center: {
            lat: getGoogleMapsLat(),
            lng: getGoogleMapsLong(),
        },
        zoom: ZOOM_INITIAL,
    });

    return map;
}
